import { Directive, ElementRef, inject, Renderer2 } from '@angular/core';

@Directive({
  selector: 'img[appImageFallback]',
  standalone: true,
  host: {
    '(error)': 'onError()'
  }
})
export class ImageFallbackDirective {
  private readonly elementRef = inject<ElementRef<HTMLImageElement>>(ElementRef);
  private readonly renderer = inject(Renderer2);
  private fellBack = false;

  protected onError(): void {
    if (this.fellBack) {
      return;
    }
    this.fellBack = true;

    const img = this.elementRef.nativeElement;
    const parent = this.renderer.parentNode(img);
    if (!parent) {
      return;
    }

    const placeholder = this.renderer.createElement('div');
    for (const cls of img.className.split(' ').filter(Boolean)) {
      this.renderer.addClass(placeholder, cls);
    }
    this.renderer.addClass(placeholder, 'thumb--placeholder');

    const icon = this.renderer.createElement('i');
    this.renderer.addClass(icon, 'pi');
    this.renderer.addClass(icon, 'pi-image');
    this.renderer.appendChild(placeholder, icon);

    this.renderer.insertBefore(parent, placeholder, img);
    this.renderer.removeChild(parent, img);
  }
}
